// extracted by mini-css-extract-plugin
module.exports = {"hdContainer":"holdingActivity_hdContainer__2LC3E"};